module.exports = __webpack_public_path__ + "img/bgpic-icon.62e59506.svg";